import dayjs from "dayjs";
import "dayjs/locale/en-ca";

export const useDateUtils = (): {
  formatDate: (value: number | string | Date | null | undefined) => string;
} => {
  const formatDate = (value: number | string | Date | null | undefined): string => {
    if (!value && value !== 0) return "--";

    let date: Date | null = null;

    if (value instanceof Date) {
      date = value;
    } else if (typeof value === "number") {
      // Treat numeric timestamps as seconds when reasonably small, otherwise milliseconds
      const millis = value < 10_000_000_000 ? value * 1000 : value;
      date = new Date(millis);
    } else if (typeof value === "string") {
      const trimmed = value.trim();
      // Support ISO-like strings and YYYY-MM-DD strings
      const isoCandidate = trimmed.includes("T") ? trimmed : `${trimmed}T00:00:00`;
      const parsed = dayjs(isoCandidate);
      date = parsed.isValid() ? parsed.toDate() : null;
    }

    if (!date || Number.isNaN(date.getTime())) return "--";

    return dayjs(date).format("MMM D, YYYY");
  };

  return {
    formatDate,
  };
};
